import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  setisGlobalCornerRoundingApplied,
  setisisGlobalBorderThicknessApplied,
  setisGlobalMarginApplied,
  setisGlobalHeadingPropsApplied,
  setisGlobalParagraphPropsApplied,
  setisGlobalLineHeightApplied,
  setisGlobalSettingsApplied,
} from "../redux/reducers/segmentBuilder";
import {
  getGlobalSettings,
  getisGlobalBorderThicknessApplied,
  getisGlobalCornerRoundingApplied,
  getisGlobalHeadingPropsApplied,
  getisGlobalLineHeightApplied,
  getisGlobalMarginApplied,
  getisGlobalParapgraphPropsApplied,
  getisGlobalSettingsApplied,
} from "../redux/selectors/segmentBuilderSelectors";
import { updateTextStyles } from "../redux/reducers/PrevStylesCopy/CodeblockDefaultStyles";

export const CODEBLOCK_TYPES = {
  Container: "Container",
  Buttons: "Buttons",
  Divider: "Divider",
  Image: "Image",
  Video: "Video",
  Audio: "Audio",
  Document: "Document",
  ImageGrid: "ImageGrid",
  Accordion: "Accordion",
  Text: "Text",
  ImageWithText: "ImageWithText",
  LinkWheel: "LinkWheel",
  SocialMediaLinks: "SocialMediaLinks",
};

const useApplyGlobalSettings = (setProp, codeBlockType) => {
  const globalSettings = useSelector(getGlobalSettings);

  const isContainerCodeBlock = codeBlockType === CODEBLOCK_TYPES.Container;
  const isButtonCodeblock = codeBlockType === CODEBLOCK_TYPES.Buttons;

  const isGlobalCornerRoundingApplied = useSelector(
    getisGlobalCornerRoundingApplied
  );
  const isGlobalBorderThicknessApplied = useSelector(
    getisGlobalBorderThicknessApplied
  );
  const isGlobalMarginApplied = useSelector(getisGlobalMarginApplied);

  const isGlobalHeadingPropsApplied = useSelector(
    getisGlobalHeadingPropsApplied
  );
  const isGlobalParagraphPropsApplied = useSelector(
    getisGlobalParapgraphPropsApplied
  );
  const isGlobalLineHeightApplied = useSelector(getisGlobalLineHeightApplied);

  const dispatch = useDispatch();

  const isGlobalSettingsApplied = useSelector(getisGlobalSettingsApplied);

  useEffect(() => {
    if (isGlobalCornerRoundingApplied || isGlobalSettingsApplied) {
      if (isContainerCodeBlock) {
        setProp((props) => {
          props.radius = globalSettings.cornerRounding;
        });
      } else if (isButtonCodeblock) {
        setProp((props) => {
          props.allButtons = props?.allButtons?.map((button) => {
            return { ...button, radius: globalSettings.cornerRounding };
          });
        });
      } else {
        //some codeblocks might not have borderRadius
        setProp((props) => {
          if (props?.borderRadius !== undefined) {
            props.borderRadius = globalSettings.cornerRounding;
          }
        });
      }

      dispatch(setisGlobalCornerRoundingApplied(false));
      dispatch(setisGlobalSettingsApplied(false));
    }
  }, [
    globalSettings.cornerRounding,
    isGlobalCornerRoundingApplied,
    setProp,
    isGlobalSettingsApplied,
  ]);

  useEffect(() => {
    if (isGlobalBorderThicknessApplied || isGlobalSettingsApplied) {
      setProp((props) => {
        if (props?.border?.width !== undefined && isContainerCodeBlock) {
          props.border.width = globalSettings.borderThickness;
        } else if (isButtonCodeblock) {
          props.allButtons = props?.allButtons?.map((button) => {
            return {
              ...button,
              border: {
                ...button.border,
                width: globalSettings.borderThickness,
              },
            };
          });
        } else if (props?.borderWidth !== undefined) {
          props.borderWidth = globalSettings.borderThickness;
        }
      });
      dispatch(setisisGlobalBorderThicknessApplied(false));
      dispatch(setisGlobalSettingsApplied(false));
    }
  }, [
    globalSettings.borderThickness,
    isGlobalBorderThicknessApplied,
    setProp,
    isGlobalSettingsApplied,
  ]);

  useEffect(() => {
    if (isGlobalMarginApplied || isGlobalSettingsApplied) {
      setProp((props) => {
        if (props?.margin !== undefined) {
          props.margin = globalSettings.margin;
        }
      });
      dispatch(setisGlobalMarginApplied(false));
      dispatch(setisGlobalSettingsApplied(false));
    }
  }, [
    globalSettings.margin,
    isGlobalMarginApplied,
    setProp,
    isGlobalSettingsApplied,
  ]);

  useEffect(() => {
    if (isGlobalHeadingPropsApplied || isGlobalSettingsApplied) {
      setProp((props) => {
        if (props?.headingProps !== undefined) {
          props.headingProps = globalSettings.headingProps;
        }
      });
      
      dispatch(setisGlobalHeadingPropsApplied(false));
      dispatch(setisGlobalSettingsApplied(false));
    }
  }, [
    globalSettings.headingProps,
    isGlobalHeadingPropsApplied,
    isGlobalSettingsApplied,
  ]);

  useEffect(() => {
    if (isGlobalParagraphPropsApplied || isGlobalSettingsApplied) {
      setProp((props) => {
        if (props?.paragraphProps !== undefined) {
          props.paragraphProps = globalSettings.paragraphProps;
        }
      });
      dispatch(setisGlobalParagraphPropsApplied(false));
      dispatch(setisGlobalSettingsApplied(false));
    }
  }, [
    globalSettings.paragraphProps,
    isGlobalParagraphPropsApplied,
    isGlobalSettingsApplied,
  ]);

  useEffect(() => {
    if (isGlobalLineHeightApplied || isGlobalSettingsApplied) {
      setProp((props) => {
        if (props?.lineHeight !== undefined) {
          props.lineHeight = globalSettings.lineHeight;
        }
      });
      dispatch(setisGlobalLineHeightApplied(false));
      dispatch(setisGlobalSettingsApplied(false));
    }
  }, [
    globalSettings.lineHeight,
    isGlobalLineHeightApplied,
    isGlobalSettingsApplied,
  ]);
};

export default useApplyGlobalSettings;
